// removed by extract-text-webpack-plugin
module.exports = {"base":"Schedule_base--1lU3e","base__tooltip":"Schedule_base__tooltip--26E_a","baseTooltip":"Schedule_base__tooltip--26E_a","title":"Schedule_title--2jL_N","item":"Schedule_item--1GbIK","periphery":"Schedule_periphery--1zO6R"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Schedule/Schedule.scss
// module id = 508
// module chunks = 11 12